// extracted by mini-css-extract-plugin
export default {"p":"QgnWMR7fmVcURHXrkzzN","historyLink":"Ywch08yrYL_CFDBkwQ2E","placeHolderShimmer":"ITC_0L4if0PMqskSf_lm"};